const html = document.documentElement;
const body = document.body;

export function resetScrollbar() {
	html.style.overflowY = '';
	body.style.overflowY = '';
}

export function hideScrollbar() {
	html.style.overflowY = 'hidden';
	body.style.overflowY = 'hidden';
}

export function getScrollbarWidth() {
	let scrollbarWidth = 0;

	if (getWindowWidth() !== getBodyWidth()) {
		const scrollDivWrapper = document.createElement('div');
		const scrollDivContent = document.createElement('div');
		scrollDivWrapper.className = 'body-overflow-measure';
		scrollDivContent.className = 'body-overflow-measure-content';
		scrollDivWrapper.appendChild(scrollDivContent);
		body.appendChild(scrollDivWrapper);
		scrollbarWidth =
			scrollDivWrapper.getBoundingClientRect().width -
			scrollDivContent.getBoundingClientRect().width;
		body.removeChild(scrollDivWrapper);
	}

	return Math.floor(scrollbarWidth);
}

export function setOverflowScroll() {
	const measureDiv = document.createElement('div');
	measureDiv.className = 'body-overflow-measure';
	body.appendChild(measureDiv);
	if (
		window.getComputedStyle(html).overflowY !== 'visible' &&
		window.getComputedStyle(html).overflowY !== 'hidden' &&
		html.scrollHeight > html.clientHeight
	) {
		html.style.overflowY = 'scroll';
	} else if (
		window.getComputedStyle(body).overflowY !== 'visible' &&
		window.getComputedStyle(body).overflowY !== 'hidden' &&
		body.scrollHeight > body.clientHeight
	) {
		body.style.overflowY = 'scroll';
	}
	body.removeChild(measureDiv);
}

export function getWindowWidth() {
	return Math.max(window.innerWidth);
}

export function getWindowHeight() {
	return Math.max(window.innerHeight);
}

export function getBodyWidth() {
	return Math.max(
		body.offsetWidth,
		html.clientWidth,
		parseInt(window.getComputedStyle(body).width, 10),
	);
}

export function getHeaderHeight() {
	return Math.max(
		$('.site-header').height(),
		document.getElementsByClassName('site-header')[0].offsetHeight,
	);
}

export function getElementHeight(el) {
	const element = document.querySelector(el);
	if (!element) {
		return false;
	}
	const style = getComputedStyle(element);
	return Math.max(parseInt(style.height, 10), element.offsetHeight);
}

export const getCookie = (cookieName) => {
	if (!cookieName) return;

	const cookies = document.cookie.split(';');
	for (let i = 0; i < cookies.length; i++) {
		const [key, value] = cookies[i].trim().split('=');
		if (key === cookieName) {
			return value;
		}
	}

	return null;
};

export const saveCookie = (cookieName, cookieValue) => {
	if (!cookieName) return;
	if (!cookieValue) return;

	document.cookie = `${cookieName}=${cookieValue};`;
};

export const removeCookie = (cookieName) => {
	if (!cookieName) return;

	document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};

// Set up the throttler
export const throttle = (fn, delay) => {
	// Capture the current time
	let time = Date.now();

	// Here's our logic
	return () => {
		if (time + delay - Date.now() <= 0) {
			// Run the function we've passed to our throttler,
			// and reset the `time` variable (so we can check again).
			fn();
			time = Date.now();
		}
	};
};
